import React from 'react';
import { Modal } from 'antd';

/**
 * Mostra uma modal de erro no sistema.
 * @param {Error} e - Erro do javascript, se o ambiente for dev, será exibido o stack do erro
 * @param {ModalFuncProps} [config=] config - configurações do modal do ant design
 */
export default (e, config) => {
  let msg = 'Algo de errado aconteceu, por favor tente novamente.';
  if (e.response && e.response.data && e.response.data.status === 400) {
    msg = e.response.data.message;
  }

  if (e.response?.data && e.response.data.statusCode >= 400 && e.response.data.statusCode < 500) {
    msg = e.response.data.message;
  }

  if (process.env.development) {
    msg = e.stack;
  }

  Modal.error({
    title: 'Ops...',
    content: React.createElement('div', { style: { whiteSpace: 'pre-line' } }, msg),
    centered: true,
    afterClose: () => {},
    ...config,
  });
};
